export const CHANGE_PASS_REQUESTING       = 'CHANGE_PASS_REQUESTING'
export const CHANGE_PASS_SUCCESS  = 'CHANGE_PASS_SUCCESS'
export const CHANGE_PASS_ERROR    = 'CHANGE_PASS_ERROR'  
export const CHANGE_PASS_POST_API    = '/api/v1/users/password'  


// WEBPACK FOOTER //
// ./src/views/Pages/ChangePassword/constants.js